import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { RadioGroupModal } from '../../Radio'

import {
  DRAFT_CLOSE_ACTION_SELECT_MODAL_FIELD_ACTION,
  DRAFT_CLOSE_ACTION_SELECT_MODAL_INITIAL_VALUES,
} from './DraftCloseActionSelectModal.constants'
import { getDraftCloseActionSelectModalOptions } from './DraftCloseActionSelectModal.utils'

function DraftCloseActionSelectModal({
  cancelTextKey,
  discardLabelKey,
  formFieldsProps: {
    titleKey: formFieldsTitleKey,
    ...formFieldsProps
  } = EMPTY_OBJECT,
  initialValues = DRAFT_CLOSE_ACTION_SELECT_MODAL_INITIAL_VALUES,
  saveLabelKey,
  submitTextKey,
  titleKey,
  onCancel,
  onSubmit,
  ...modalProps
}) {
  const { t } = useTranslation()

  const getOptions = useCallback(
    () =>
      getDraftCloseActionSelectModalOptions({
        discardLabelKey,
        saveLabelKey,
        t,
      }),
    [discardLabelKey, saveLabelKey, t]
  )

  const handleSubmit = useCallback(
    ({ [DRAFT_CLOSE_ACTION_SELECT_MODAL_FIELD_ACTION]: action }) => {
      onSubmit?.(action)
    },
    [onSubmit]
  )

  return (
    <RadioGroupModal
      {...modalProps}
      formFieldsProps={{
        ...formFieldsProps,
        cancelProps: {
          ...formFieldsProps.cancelProps,
          title: cancelTextKey,
        },
        getOptions,
        name: DRAFT_CLOSE_ACTION_SELECT_MODAL_FIELD_ACTION,
        submitProps: {
          ...formFieldsProps.submitProps,
          title: submitTextKey,
        },
        title: t(formFieldsTitleKey),
      }}
      initialValues={initialValues}
      title={t(titleKey)}
      onCancel={onCancel}
      onClose={onCancel}
      onSubmit={handleSubmit}
    />
  )
}

export default DraftCloseActionSelectModal
